<h1 mat-dialog-title>Table Options</h1>
<mat-dialog-content>
    <section>
        <mat-form-field>
            <mat-label>Columns</mat-label>
            <mat-select value="standard" [disabled]="disable" [(ngModel)]="columns">
                <mat-option *ngFor="let opt of columnsOpts" [value]="opt.value">{{opt.label}}</mat-option>
                <!-- <mat-option value="standard">Standard</mat-option>
                <mat-option value="nobase">nobase</mat-option>
                <mat-option value="TA">TA</mat-option>
                <mat-option value="A">A</mat-option> -->
            </mat-select>
        </mat-form-field>
        <mat-form-field
            *ngIf="data.reportCache.report_type === 'linescore' || data.reportCache.report_type === 'concept_linescore'">
            <!-- <mat-label>Row Percent</mat-label> -->
            <mat-label>Show as</mat-label>
            <mat-select [disabled]="disable" [(ngModel)]="rowPercent">
                <mat-option [value]="true">row distribution</mat-option>
                <mat-option [value]="false">column distribution</mat-option>
            </mat-select>
        </mat-form-field>
    </section>
    <mat-progress-bar mode="indeterminate" *ngIf="disable"></mat-progress-bar>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button class="icon-text-btn" (click)="process()" [disabled]="disable">
        <mat-icon>autorenew</mat-icon>
        <span>Done</span>
    </button>
</mat-dialog-actions>